import { render, staticRenderFns } from "./right-bar.vue?vue&type=template&id=05c86e01"
import script from "./right-bar.vue?vue&type=script&lang=js"
export * from "./right-bar.vue?vue&type=script&lang=js"
import style0 from "./right-bar.vue?vue&type=style&index=0&id=05c86e01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports